import React from "react";
import { Route, Redirect } from "react-router-dom";
import Layout from "@Core/Components/Layout";
import { get } from "@Core/LocalStorage";
const PrivateRoute = ({
  component,
  isAuthenticated = false,
  ...rest
}) => {
  const srmwuiCustomerObj = get('srmwuiCustomerObj') || {}
  const userTokenData = srmwuiCustomerObj && Object.keys(srmwuiCustomerObj).length ? srmwuiCustomerObj.userToken : '';
  let isLogin = userTokenData ? true : false;
  // let isLogin = true;

  return (
    !isLogin ? <Redirect to={process.env.REACT_APP_LOGIN_ROUTE} />
      :
      <Route
        {...rest}
        render={(props) =>
          <Layout Component = {component} {...props}/>        
        }
      />
  );
};
export default PrivateRoute;
